import { SET_AUTH_AGENT_FORM_VALUES } from "../actions/types";

const initialState = {
  entity_name: "",
  phone_number: "",
  entity_email: "",
  entity_email_confirm: "",
  street_address: "",
  secondary_address: "",
  zip_code: "",
  city: "",
  state: ""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AUTH_AGENT_FORM_VALUES:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
